import gql from 'graphql-tag';

export const REGISTER_MEMBER_CLASS = gql`
  mutation(
    $member_no: Int!
    $golf_group_code: String!
    $golf_code: String!
    $member_class: Int!
  ){
    registerMemberClass(
      member_no: $member_no,
      golf_group_code: $golf_group_code,
      golf_code: $golf_code,
      member_class: $member_class,
    ){
      result
      errorMessage
    }
  },
`;

export const CHANGE_MEMBER_CLASS = gql`
  mutation(
    $id: ID!
    $member_class: Int!
  ){
    changeMemberClass(
      id: $id,
      member_class: $member_class
    ){
      result
      errorMessage
    }
  }
`;

export const DELETE_MEMBER_CLASS = gql`
  mutation(
    $id: ID!
  ){
    deleteMemberClass(
      id: $id
    ){
      result
      errorMessage
    }
  }
`;

export const GET_MEMBER_CLASS_LIST = gql`
  query(
    $member_no: Int!
    $limit_rows: Int!
    $begin_row: Int!
  ){
    getMemberClassList(
      member_no: $member_no
      limit_rows: $limit_rows
      begin_row: $begin_row
    ){
      MemberClassList{
        id
        golf_code
        golf_name
        member_class
        created_at
      }
      count
    }
  }
`;
